// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 991px) {
  .experienceContainer h1 {
    margin-top: 20%;
    font-size: 2rem;
  }
  .tabsWrap {
    flex-direction: column;
    margin-top: 64px;
  }
  .experienceTabs {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .tabButton {
    border-width: 0px;
    font-size: large;
    color: black;
  }
  .activeTab {
    border-bottom-width: 2px;
    border-color: #56acb7;
    color: #56acb7;
  }
  .experienceInfo {
    margin-top: 24px;
    margin-left: 12px;
  }
  #dutyContainer p {
    width: 90%;
    margin-left: 12px;
  }
}
@media only screen and (min-width: 992px) {
  .experienceContainer h1 {
    margin-top: 5%;
    font-size: 3rem;
  }
  .tabsWrap {
    flex-direction: row;
    margin-top: 3%;
  }
  .experienceTabs {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }
  .tabButton {
    width: 50%;
    border-width: 0px;
    font-size: larger;
    color: black;
  }
  .activeTab {
    border-left-width: 2px;
    border-color: #56acb7;
    color: #56acb7;
  }
  .experienceInfo {
    padding-left: 24px;
    padding-right: 24px;
    height: 370px;
  }
  #dutyContainer p {
    width: 80%;
    margin-left: 24px;
  }
}

.experienceContainer {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.experienceContainer h1 {
  font-weight: 500;
}

.tabsWrap {
  width: 90%;
  display: flex;
}
.experienceTabs {
  flex: 1;
  display: flex;
}
.tabButton {
  padding: 12px;
  background-color: white;
}
.experienceInfo {
  flex: 2;
}
#datesWrapper {
  color: #7f7f7f;
}
#dutyContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/experience/Experience.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,OAAO;AACT;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B","sourcesContent":["@media only screen and (max-width: 991px) {\n  .experienceContainer h1 {\n    margin-top: 20%;\n    font-size: 2rem;\n  }\n  .tabsWrap {\n    flex-direction: column;\n    margin-top: 64px;\n  }\n  .experienceTabs {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n  .tabButton {\n    border-width: 0px;\n    font-size: large;\n    color: black;\n  }\n  .activeTab {\n    border-bottom-width: 2px;\n    border-color: #56acb7;\n    color: #56acb7;\n  }\n  .experienceInfo {\n    margin-top: 24px;\n    margin-left: 12px;\n  }\n  #dutyContainer p {\n    width: 90%;\n    margin-left: 12px;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .experienceContainer h1 {\n    margin-top: 5%;\n    font-size: 3rem;\n  }\n  .tabsWrap {\n    flex-direction: row;\n    margin-top: 3%;\n  }\n  .experienceTabs {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-end;\n  }\n  .tabButton {\n    width: 50%;\n    border-width: 0px;\n    font-size: larger;\n    color: black;\n  }\n  .activeTab {\n    border-left-width: 2px;\n    border-color: #56acb7;\n    color: #56acb7;\n  }\n  .experienceInfo {\n    padding-left: 24px;\n    padding-right: 24px;\n    height: 370px;\n  }\n  #dutyContainer p {\n    width: 80%;\n    margin-left: 24px;\n  }\n}\n\n.experienceContainer {\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.experienceContainer h1 {\n  font-weight: 500;\n}\n\n.tabsWrap {\n  width: 90%;\n  display: flex;\n}\n.experienceTabs {\n  flex: 1;\n  display: flex;\n}\n.tabButton {\n  padding: 12px;\n  background-color: white;\n}\n.experienceInfo {\n  flex: 2;\n}\n#datesWrapper {\n  color: #7f7f7f;\n}\n#dutyContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
